// Clipboard access for components that offer a copy affordance (EBizGrid's CopyableTextColumn).
// The async Clipboard API is only available in a secure context — https, or localhost during
// development. Served over plain http it is simply absent from `navigator`, so the legacy
// execCommand path below is the fallback rather than an error, and callers get a bool either way.
window.ebizclipboard = {
    copyText: async function (text) {
        if (text === null || text === undefined) {
            return false;
        }

        text = String(text);

        if (navigator.clipboard && navigator.clipboard.writeText) {
            try {
                await navigator.clipboard.writeText(text);
                return true;
            } catch {
                // Permission denied or a non-focused document — fall through and try execCommand.
            }
        }

        return copyViaExecCommand(text);
    }
};

// Pre-Clipboard-API fallback: selection + execCommand("copy") off an offscreen textarea.
// Deprecated but still universally implemented, and the only option outside a secure context.
function copyViaExecCommand(text) {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    // Keep it out of view and out of the tab order, and avoid the scroll jump a focused
    // offscreen element would otherwise cause.
    textarea.setAttribute("readonly", "");
    textarea.setAttribute("aria-hidden", "true");
    textarea.tabIndex = -1;
    textarea.style.position = "fixed";
    textarea.style.top = "0";
    textarea.style.left = "-9999px";

    document.body.appendChild(textarea);

    const previouslyFocused = document.activeElement;
    try {
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);
        return document.execCommand("copy");
    } catch {
        return false;
    } finally {
        document.body.removeChild(textarea);
        if (previouslyFocused && typeof previouslyFocused.focus === "function") {
            previouslyFocused.focus();
        }
    }
}
